<section class="surveys uscb-layout-row uscb-layout-align-center-center sspacer">
    <section class="uscb-flex">
        <div class="uscb-layout-column">
            <div class="uscb-layout-row uscb-layout-align-space-between uscb-layout-align-vert-center">
                <h1 class="uscb-flex uscb-title-1">
                    My Surveys
                </h1>
                <div class="uscb-flex uscb-layout-align-end-end">
                    <button class="uscb-primary-button" (click)="showHelp()" (keyup.enter)="showHelp()" tabindex="0">
                        Help
                    </button>
                </div>
            </div>
            <app-linear-loading [loading]="isLoading()"></app-linear-loading>
            @if (currentActiveSurveys()?.length === 0 && currentInactiveSurveys()?.length === 0 && !isLoading()) {
            <span class="uscb-flex top-padding">No surveys
                associated with this user</span>
            }
        </div>

        <div class="uscb-layout-column {{ currentView() }}-tab uscb-margin-T-15">
        
                <!-- TAB BUTTONS -->
                <app-custom-tabs [tabs]="tabs" [selectedIndex]="selectedTabIndex" (tabChange)="onTabClick($event)">
                </app-custom-tabs>
        
                <!-- TAB CONTENT -->
                <div class="tab-content">
                    @for (tab of tabs; track tab.label; let i = $index) {
                    @if (selectedTabIndex === i) {
        
                    <div class="ecorr-padding-BTM-sm">
                        <div class="select-view uscb-margin-T-5">
                            <span class="view-label">&nbsp;&nbsp;VIEW: &nbsp;</span>
                            <button (click)="switchView('grid')" (keyup.enter)="switchView('grid')"
                                [ngClass]="{ 'ecorr-button-active' : currentView() === 'grid', 'ecorr-button-inactive' : currentView() !== 'grid' }"
                                mat-button tabindex="0">
                                <i class="fa fa-th-large"></i>&nbsp;&nbsp; <span>GRID</span>
                            </button>
                            <button mat-button (click)="switchView('list')" (keyup.enter)="switchView('list')"
                                [ngClass]="{ 'ecorr-button-active' : currentView() === 'list', 'ecorr-button-inactive' : currentView() !== 'list' }"
                                tabindex="0">
                                <i class="fa fa-th-list"></i>&nbsp;&nbsp; <span>LIST</span>
                            </button>
                            @if (isActive()) {
                            <button mat-button (click)="switchView('calendar')" (keyup.enter)="switchView('calendar')"
                                [ngClass]="{ 'ecorr-button-active' : currentView() === 'calendar', 'ecorr-button-inactive' : currentView() !== 'calendar' }"
                                tabindex="0">
                                <i class="fa fa-calendar"></i>&nbsp;&nbsp; <span>CALENDAR</span>
                            </button>
                            }
                        </div>
                    </div>
        
                    <!-- VIEWS -->
                    @if (currentView() === 'grid') {
                    <app-grid-view [surveys]="isActive() ? currentActiveSurveys() : currentInactiveSurveys()"
                        [active]="isActive()" [overdue-message]="currentOverdueMessage()" [add-survey-text]="'Received a new survey request? Add it with your Authentication Code to get started.'">
                    </app-grid-view>
                    }
        
                    @if (currentView() === 'list') {
                    <app-list-view [surveys]="isActive() ? currentActiveSurveys() : currentInactiveSurveys()"
                        [active]="isActive()">
                    </app-list-view>
                    }
        
                    @if (currentView() === 'calendar') {
                    <app-calendar-view [surveys]="isActive() ? currentActiveSurveys() : currentInactiveSurveys()"
                        [active]="isActive()" [overdue-message]="currentOverdueMessage()">
                    </app-calendar-view>
                    }
        
                    }
                    }
                </div>
        </div>
    </section>
</section>
